export enum ProductVersionTabs {
    PRODUCT_VERSIONS = 'Product Versions',
    PRODUCT_MATERIALS = 'Product Materials',
    PRODUCT_FUNCTIONS = 'Product Functions',
}
